import {
  Bell as BellIcon,
  Book as BookIcon,
  Codesandbox as CodesandboxIcon,
  DollarSign as DollarSignIcon,
  Edit as EditIcon,
  Eye as EyeIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Shield as ShieldIcon,
  Tool as ToolIcon,
  UserCheck as UserCheckIcon,
} from 'react-feather'

// 'routes' é obtido via require() dentro de cada função 'route' (não no topo do
// arquivo) porque este arquivo é importado por 'constants/index', que por sua vez
// é importado por 'Routes.js' - um import estático aqui criaria uma referência
// circular entre os dois módulos.
const getRoutes = () => require('Routes').routes

// Os ids representam os ids dos tipos de solicitação na plataforma de tickets (Tomticket)
const SOLICITATION_SUPPORT_ID = '44e59155be40145595bf37fb86143360' // Dúvida da plataforma
const SOLICITATION_FINANCIAL_ID = '2a24c6cc95fada86fb8bd00ef27e9118' // Dúvida sobre o Financeiro
const SOLICITATION_OTHERS_ID = '1a2dd039bd2c79fbae911f59056dfdd1' // Outro

const ALL_SOLICITATION_CATEGORIES = [
  SOLICITATION_SUPPORT_ID,
  SOLICITATION_FINANCIAL_ID,
  SOLICITATION_OTHERS_ID,
]

const SOLICITATION_ITEMS = [
  { id: SOLICITATION_SUPPORT_ID, name: 'Suporte' },
  { id: SOLICITATION_FINANCIAL_ID, name: 'Financeiro' },
  { id: SOLICITATION_OTHERS_ID, name: 'Outros' },
]

// As propriedades 'route' precisam ser funções porque este arquivo é carregado antes de Routes.js.
// Isso evita erros de referência circular e garante que as rotas sejam resolvidas apenas quando necessário.

const HELP_CENTER_REQUEST_ASSISTANCE_ID = 'requestAssistance'
const HELP_CENTER_MY_REQUESTS_ID = 'myRequests'
const HELP_CENTER_LATEST_UPDATES_ID = 'latestUpdates'
const HELP_CENTER_FAQS_ID = 'faqs'
const HELP_CENTER_PLATFORM_FAQS_ID = 'platformFaqs'
const HELP_CENTER_FINANCIAL_ID = 'financial'

const HELP_CENTER_OPTIONS = [
  {
    id: HELP_CENTER_REQUEST_ASSISTANCE_ID,
    icon: PlusIcon,
    title: 'Solicitar atendimento',
    selected: true,
    route: () => {},
  },
  {
    id: HELP_CENTER_MY_REQUESTS_ID,
    icon: EyeIcon,
    title: 'Minhas solicitações',
    route: () => {},
  },
  {
    id: HELP_CENTER_LATEST_UPDATES_ID,
    icon: BellIcon,
    title: 'Últimas atualizações',
    route: () => getRoutes().lastUpdates.all,
  },
  {
    id: HELP_CENTER_FAQS_ID,
    icon: BookIcon,
    title: 'Faq’s de Governança e de SI',
    route: () => {},
  },
  {
    id: HELP_CENTER_PLATFORM_FAQS_ID,
    icon: SearchIcon,
    title: 'FAQs da plataforma',
    route: () => getRoutes().faqsDocumentations.all,
  },
  {
    id: HELP_CENTER_FINANCIAL_ID,
    icon: DollarSignIcon,
    title: 'Segunda Via e Pagamentos',
    route: () => ({
      pathname: getRoutes().settings,
      state: { tab: 'financial' },
    }),
  },
]

const HELP_CENTER_SOLICITATION_LEGAL_ID = 'legal'
const HELP_CENTER_SOLICITATION_SI_ID = 'informationSecurity'
const HELP_CENTER_SOLICITATION_TECHNICAL_SUPPORT_ID = 'technicalSupport'
const HELP_CENTER_SOLICITATION_CONTRACT_REVISION_ID = 'contractRevision'
const HELP_CENTER_SOLICITATION_THIRD_PARTY_ASSESSMENT_ID =
  'thirdPartyAssessment'
const HELP_CENTER_SOLICITATION_FINANCIAL_ID = 'financial'
const HELP_CENTER_SOLICITATION_OTHERS_ID = 'others'

const HELP_CENTER_SOLICITATION_OPTIONS = [
  {
    id: HELP_CENTER_SOLICITATION_LEGAL_ID,
    title: 'Privacidade',
    content: [
      'Dúvidas sobre LGPD',
      'Dúvidas Técnicas sobre Privacidade e Adequação à LGPD',
    ],
    icon: CodesandboxIcon,
    route: () => getRoutes().technicalFaqs.lgpd.ticket,
  },
  {
    id: HELP_CENTER_SOLICITATION_SI_ID,
    title: 'Segurança da Informação',
    content: [
      'Dúvidas sobre segurança de redes, sistemas, gestão',
      'Resposta a incidentes de segurança',
    ],
    icon: ShieldIcon,
    route: () => getRoutes().technicalFaqs.informationSecurity.ticket,
  },
  {
    id: HELP_CENTER_SOLICITATION_CONTRACT_REVISION_ID,
    title: 'Revisão de Contratos',
    content: ['Análise de cláusulas contratuais de LGPD'],
    icon: EditIcon,
    route: () => getRoutes().technicalFaqs.contracts.ticket,
  },
  {
    id: HELP_CENTER_SOLICITATION_THIRD_PARTY_ASSESSMENT_ID,
    title: 'Parecer de avaliações recebidas',
    content: [
      'Auditorias de terceiros',
      'Diligências recebidas de fornecedores',
    ],
    icon: UserCheckIcon,
    route: () => getRoutes().technicalFaqs.thirdPartyAssessment.ticket,
  },
  {
    id: HELP_CENTER_SOLICITATION_TECHNICAL_SUPPORT_ID,
    title: 'Suporte Técnico',
    content: ['Dúvidas sobre plataforma', 'Erros e problemas técnicos'],
    icon: ToolIcon,
    route: () =>
      `${
        getRoutes().helpCenter.solicitation
      }?category=${SOLICITATION_SUPPORT_ID}`,
  },
  {
    id: HELP_CENTER_SOLICITATION_FINANCIAL_ID,
    title: 'Financeiro',
    content: ['Dúvidas financeiras', 'Geração de boletos e notas'],
    icon: DollarSignIcon,
    route: () =>
      `${
        getRoutes().helpCenter.solicitation
      }?category=${SOLICITATION_FINANCIAL_ID}`,
  },
]

const HELP_CENTER_FAQ_OPTIONS = [
  {
    title: 'Governança',
    content:
      'Se você tem dúvidas sobre a LGPD, análise de cláusulas contratuais ou dúvidas jurídicas relacionadas à plataforma.',
    route: () => getRoutes().technicalFaqs.lgpd.main,
  },
  {
    title: 'Segurança da Informação',
    content:
      'Dúvidas sobre segurança da informação, segurança de redes e sistemas, gestão de senhas e controle de acesso, ou resposta a incidentes de segurança.',
    route: () => getRoutes().technicalFaqs.informationSecurity.main,
  },
]

const HELP_CENTER_TICKET_OPTIONS = [
  {
    id: 'internalTickets',
    title: 'Privacidade e SI',
    subTitle:
      'Você será redirecionado para a tela “Central da Privacidade” na guia “minhas solicitações”.',
    route: () => getRoutes().technicalFaqs.tickets.all,
  },
  {
    id: 'externalTickets',
    title: 'Suporte Técnico ou Financeiro',
    subTitle: 'Você será redirecionado para a plataforma de tickets.',
    route: () => {},
  },
]

const HELP_CENTER_MAIN_DRIVER_STEP_0 = 'help-center-main-driver-step-0'

const HELP_CENTER_MAIN_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + HELP_CENTER_MAIN_DRIVER_STEP_0,
    popover: {
      description:
        'Bem-vindo ao canal de atendimento! Tire suas dúvidas com a assistente virtual <strong>Dai</strong>, especializada em <strong>LGPD</strong>. Se necessário, solicite atendimento com um especialista. Também é possível acessar suas solicitações anteriores, consultar atualizações da plataforma e as <strong>FAQs</strong> sobre governança, segurança da informação e uso da plataforma.',
    },
  },
]

export default {
  ALL_SOLICITATION_CATEGORIES,
  HELP_CENTER_FAQ_OPTIONS,
  HELP_CENTER_FAQS_ID,
  HELP_CENTER_FINANCIAL_ID,
  HELP_CENTER_LATEST_UPDATES_ID,
  HELP_CENTER_MAIN_DRIVER_STEP_0,
  HELP_CENTER_MAIN_DRIVER_STEPS_OBJECT,
  HELP_CENTER_MY_REQUESTS_ID,
  HELP_CENTER_OPTIONS,
  HELP_CENTER_PLATFORM_FAQS_ID,
  HELP_CENTER_REQUEST_ASSISTANCE_ID,
  HELP_CENTER_SOLICITATION_FINANCIAL_ID,
  HELP_CENTER_SOLICITATION_LEGAL_ID,
  HELP_CENTER_SOLICITATION_OPTIONS,
  HELP_CENTER_SOLICITATION_OTHERS_ID,
  HELP_CENTER_SOLICITATION_SI_ID,
  HELP_CENTER_SOLICITATION_TECHNICAL_SUPPORT_ID,
  HELP_CENTER_TICKET_OPTIONS,
  SOLICITATION_FINANCIAL_ID,
  SOLICITATION_ITEMS,
  SOLICITATION_OTHERS_ID,
  SOLICITATION_SUPPORT_ID,
}
